import { CSSProperties } from 'react';

import type { TeamDayResource, TeamDayResourceWithColumn } from '../TeamDayView/types';
import { sanitizeTeamMemberName } from './teamCopyUtils';
type TeamTFunction = (
  key: string,
  options?: Record<string, unknown> & { defaultValue?: string }
) => string;

export const normalizeResourceId = (resourceId?: string | number) => {
  return resourceId ? String(resourceId) : '';
};

export const getFirstName = (name: string, t?: TeamTFunction) => {
  return (
    sanitizeTeamMemberName(name).split(/\s+/)[0] ||
    (t ? t('team.common.thisTeammate') : 'This teammate')
  );
};

export const buildHiddenCalendarColumnStyles = (hiddenResources: TeamDayResourceWithColumn[]) => {
  return hiddenResources
    .map((resource) => {
      const columnSelector = `.team-day-view__calendar .rbc-time-content > .rbc-day-slot:nth-child(${
        resource.columnIndex + 2
      })`;
      return `
${columnSelector} {
  position: relative;
}

${columnSelector} .rbc-events-container,
${columnSelector} .rbc-background-event,
${columnSelector} .rbc-current-time-indicator {
  display: none !important;
}

${columnSelector}::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 7;
  pointer-events: none;
  background: repeating-linear-gradient(
    135deg,
    var(--color-gray-purple, #f9f8fc) 0,
    var(--color-gray-purple, #f9f8fc) 8px,
    var(--color-primary-lightest, #680ddb14) 8px,
    var(--color-primary-lightest, #680ddb14) 16px
  );
}
`;
    })
    .join('\n');
};

export const getHiddenCalendarCardStyle = (
  resource: TeamDayResourceWithColumn,
  resourceCount: number
): CSSProperties => {
  const safeResourceCount = Math.max(resourceCount, 1);
  const columnWidth = 100 / safeResourceCount;

  return {
    left: `${columnWidth * (resource.columnIndex + 0.5)}%`,
    width: `min(180px, calc(${columnWidth}% - 28px))`,
  };
};

export const buildResourcesWithHiddenCalendar = (
  resources: TeamDayResource[]
): TeamDayResourceWithColumn[] => {
  return resources
    .map((resource, columnIndex) => ({ ...resource, columnIndex }))
    .filter((resource) => !resource.isCalendarShared);
};
